import React, { useState } from 'react';
import PageHero from './PageHero';
import { Plus, Minus } from 'lucide-react';

export default function FaqsPage({ t, setPage }) {
  const { faqs } = t;
  const [openIndex, setOpenIndex] = useState(0);

  const navCategory = t?.nav?.[5]?.label || "Admissions";
  const homeLabel = t?.nav?.[0]?.label || "Home";

  const toggleFaq = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <div className="w-full bg-[#f8f9fa] min-h-screen pb-32">
      {/* ── Hero ─────────────────────────────────────────────────────────────── */}
      <PageHero
        title={faqs.title}
        breadcrumbs={[homeLabel, navCategory, "FAQs"]}
        eyebrow={navCategory}
        subtitle={faqs.subtitle}
      />


      {/* ── Main Content ── */}
      <div className="max-w-[1440px] mx-auto px-6 lg:px-[120px] pt-20">
        <div className="space-y-4">
          {faqs.items.map((faq, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div 
                key={idx}
                className={`bg-white rounded-2xl border transition-all duration-300 ${isOpen ? 'border-gold shadow-[0_8px_30px_rgba(200,169,126,0.15)]' : 'border-line shadow-sm hover:border-navy/30'}`}
              >
                <button
                  onClick={() => toggleFaq(idx)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none group"
                >
                  <span className={`text-[18px] md:text-[20px] font-heading font-semibold transition-colors duration-300 pr-8 ${isOpen ? 'text-gold' : 'text-navy group-hover:text-gold'}`}>
                    {faq.q}
                  </span>
                  
                  <div className={`shrink-0 w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300 ${isOpen ? 'bg-gold text-white rotate-180' : 'bg-navy/5 text-navy group-hover:bg-gold/10 group-hover:text-gold'}`}>
                    {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                  </div>
                </button>
                
                {/* 
                  Using CSS Grid for buttery smooth accordion animation.
                  fr unit transitions perfectly without hardcoded heights.
                */}
                <div 
                  className={`grid transition-[grid-template-rows] duration-500 ease-in-out ${isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}
                >
                  <div className="overflow-hidden">
                    <div className={`px-6 transition-opacity duration-500 delay-100 ${isOpen ? 'opacity-100 pb-6' : 'opacity-0 pb-0'}`}>
                      <div className="w-12 h-px bg-gold/50 mb-4"></div>
                      <p className="text-ink/80 leading-[1.8] text-[17px]">
                        {faq.a}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ── CTA Section (PreschoolPage style) ─────────────────────────────── */}
      <div className="w-full bg-white mt-16">
        <div className="max-w-[1200px] mx-auto px-8 py-12">
          <div className="relative overflow-hidden bg-navy rounded-3xl p-12 md:p-20 text-center shadow-2xl">
            <div className="relative z-10">
              <h3 className="text-4xl md:text-5xl font-heading font-bold text-white mb-6 leading-tight uppercase">
                {t?.utilAdm === 'Penerimaan' ? 'Masih Punya Pertanyaan?' : 'Still have questions?'}
              </h3>
              <p className="text-white/70 text-xl max-w-2xl mx-auto mb-10">
                {t?.utilAdm === 'Penerimaan'
                  ? 'Tim Penerimaan kami siap membantu Anda. Hubungi kami untuk informasi lebih lanjut atau jadwalkan kunjungan kampus.'
                  : 'Our admissions team is here to help. Reach out to us for more information or to schedule a campus tour.'}
              </p>
              <div className="flex flex-wrap items-center justify-center gap-4">
                <button
                  onClick={() => { if (setPage) { setPage('contact'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}}
                  className="bg-gold text-navy px-10 py-4 rounded-full font-bold text-lg tracking-wide hover:bg-white hover:text-navy transition-colors duration-300 cursor-pointer"
                >
                  {t?.utilAdm === 'Penerimaan' ? 'Hubungi Penerimaan' : 'Contact Admissions'}
                </button>
                <button
                  onClick={() => { if (setPage) { setPage('schedule-visit'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}}
                  className="bg-white/10 text-white px-10 py-4 rounded-full font-bold text-lg tracking-wide hover:bg-white/20 transition-colors duration-300 border border-white/20 cursor-pointer"
                >
                  {t?.utilAdm === 'Penerimaan' ? 'Jadwalkan Kunjungan' : 'Schedule a Visit'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
